<template>
  <div :id="uid" class="zt-accordion-item rounded w-full" :class="activeClassPanel" v-show="visible">
    <div
      class="selected-disabled zt-accordion-item--header cursor-pointer w-full flex h-24 items-center justify-between p-custom"
      :class="classes"
      @click="_onClick"
    >
      <h2 class="text-zt-lg">
        <zt-icon :name="prependIcon" v-if="prependIcon !== ''" class="mr-4 prepend-icon" />
        <span>{{ title }}</span>
      </h2>
      <zt-icon :name="iconName" class="text-zt-xl bold" />
    </div>
    <transition
        name="accordion"
        @enter="start"
        @after-enter="end"
        @before-leave="start"
        @after-leave="end"
    >
      <div
        v-show="isActiveContent"
        class="zt-accordion-item--content w-full"
      >
        <div class="p-4">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "ztAccordionItem",
  inject:{
    wrapperPanels: {
      type: Object,
      required: true
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'angle-down'
    },
    iconActive: {
      type: String,
      default: 'angle-up'
    },
    prependIcon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoCollapse: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    isActiveContent: {
      handler(value) {
        this.$emit('open', value)
      },
      immediate: true
    }
  },
  computed: {
    iconName() {
      return this.isActiveContent ? this.iconActive : this.icon
    },
    classes() {
      if (this.disabled) return 'opacity-disabled'
      if (this.isActiveContent) return 'bg-zt-dark-custom rounded-t'
      return ''
    },
    activeClassPanel() {
      return {
        'panel-is-active': this.isActiveContent
      }
    }
  },
  data() {
    return {
      isActiveContent: false,
      uid: ''
    }
  },
  methods: {
    _onClick() {
      if (this.disabled) return
      this.$emit('handleClick', this)
      this.isActiveContent = !this.isActiveContent
      if(this.autoCollapse) {
        const children = this.wrapperPanels._data.children
        for(const child of children) {
          if(child._data.uid !== this.uid && child._props.autoCollapse) {
            child._data.isActiveContent = false
          }
        }
      }

    },
    close() {
      this.isActiveContent = false
    },
    start(el) {
      el.style.height = `${el.scrollHeight}px`;
    },
    end(el) {
      el.style.height = '';
    }
  },
  mounted() {
    this.uid = this._uid
  },
  created() {
    this.wrapperPanels.$emit('create-children', this)
  }
}
</script>

<style scoped lang="scss">
h2 {
  color: #2D2D2D;
}
.selected-disabled {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.opacity-disabled {
  opacity: .65
}
.zt-accordion-item {
  background: white;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
}
.bg-zt-dark-custom {
  background: #DEDEDE;
}
.prepend-icon {
  font-size: 2.4rem;
  color: #898DFF;
}
.p-custom {
  padding: 1.25rem;
}
.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}
.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
